import $ from 'jquery';

var self = {
  elems: null,
  init: function () {
    self.elems = $('.image-expanding-block .img-expanding');
    self.resize();
    $(window).on('resizeend', function () {
      self.resize();
    });
  },
  resize: function () {
    if ($(window).width() < 1024) {
      self.elems.css({
        'width': '',
        'max-width': '',
        'margin-left': ''
      });
    } else {
      self.elems.each(function () {
        var elem = $(this);
        var componentElem = elem.closest('.image-expanding-block');
        var rowElem = elem.closest('.row');
        var colElem = elem.closest('.col-block');
        var containerOversizeElem = elem.closest('.container-paragraph, .container-oversize');
        if (componentElem.length && rowElem.length && containerOversizeElem.length) {
          var colWidth = componentElem.width();
          var containerOffset = rowElem.offset().left;
          var containerOversizeOffset = containerOversizeElem.offset().left;
          var addToWidth = containerOffset - containerOversizeOffset + 1;
          var isFullWidthCol = colElem.hasClass('col-lg-12');
          var isLeftCol = Math.abs(componentElem.offset().left - containerOffset) < 10;
          if (isFullWidthCol) {
            elem.css({
              'width': (colWidth + addToWidth * 2) + 'px',
              'max-width': 'none',
              'margin-left': -addToWidth + 'px'
            });
          } else {
            elem.css({
              'width': (colWidth + addToWidth) + 'px',
              'max-width': 'none',
              'margin-left': (isLeftCol ? -addToWidth + 'px' : '')
            });
          }
        }
      });
    }
  }
};

$(document).ready(function () {
  self.init();
});



// WEBPACK FOOTER //
// ./src/components/paragraph/image-expanding.js